var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10ZM2.22222 10C2.22222 5.70445 5.70445 2.22222 10 2.22222C14.2955 2.22222 17.7778 5.70445 17.7778 10C17.7778 14.2955 14.2955 17.7778 10 17.7778C5.70445 17.7778 2.22222 14.2955 2.22222 10ZM11.1111 5.55556C11.1111 4.94191 10.6137 4.44444 10 4.44444C9.38635 4.44444 8.88889 4.94191 8.88889 5.55556V8.88891H5.55558C4.94193 8.88891 4.44447 9.38637 4.44447 10C4.44447 10.6137 4.94193 11.1111 5.55558 11.1111H8.88889V14.4444C8.88889 15.0581 9.38635 15.5556 10 15.5556C10.6137 15.5556 11.1111 15.0581 11.1111 14.4444V11.1111H14.4445C15.0581 11.1111 15.5556 10.6137 15.5556 10C15.5556 9.38637 15.0581 8.88891 14.4445 8.88891H11.1111V5.55556Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.f35d7cb42247786cbdfdda4cc500f1a3.svg";
export { ForwardRef as ReactComponent };